import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "ManageEmp";

export const postEmployee = createAsyncThunk(
  `${namespace}/postEmployee`,
  async (body, { rejectWithValue }) => {
    const api = "personnelList";
    const opt = {
      body: { searchText: body },
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getPersonList =createAsyncThunk(
  `${namespace}/getPersonList`,
  async (body, { rejectWithValue }) => {
    const api = "getpersons";
    // getpersons
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const createPerson = createAsyncThunk(
  `${namespace}/createPerson`,
  async (body, { rejectWithValue }) => {
    const api = "personscreate";
    const opt = {
      method: "POST",
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const updatePerson = createAsyncThunk(
  `${namespace}/updatePerson`,
  async (body, { rejectWithValue }) => {
    const api = "personsupdate";
    const replace = {
      search: "id",
      replace: body.id,
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getPersonById = createAsyncThunk(
  `${namespace}/getPersonById`,
  async (body, { rejectWithValue }) => {
    console.log(body);
    const api = "getpersonbyid";
    const replace = {
      search: "id",
      replace: body,
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getPersonZktecoById = createAsyncThunk(
  `${namespace}/getPersonZktecoById`,
  async (body, { rejectWithValue }) => {
    console.log(body);
    const api = "getpersonzktecobyid";
    const replace = {
      search: "id",
      replace: body.id,
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAPerson = createAsyncThunk(
  `${namespace}/getAPerson`,
  async (body, { rejectWithValue }) => {
    console.log(body);
    const api = "getAperson";
    const replace = {
      search: "{sid}",
      replace: body.id,
    };
    const opt = {
      replace: replace,
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  personnelReport: {
    grade: "",
    s_id: "",
    zkteco_fullname: "",
    fullname: "",
    department: {
        id:"",
    },  
    superior: {
        id: "",
    },
    left: "",
    joined: "",
    created: "" ,
    status: 1,
  },
    currentPage: 1,
    personnels:[],
    personsLists:[],
    personnelReportZk: {},
  };
  

const manageEmpSlice = createSlice({
  name: "manageEmp",
  initialState,
  reducers: {
    updatePersonnelReport(state, action) {
      return { ...state, personnelReport: action.payload };
    },
    resetPersonnelReport(state, action) {
      return { ...state, personnelReport:initialState.personnelReport };
    },
    updateCurrentPage(state, action) {
      return { ...state, currentPage: action.payload };
    },
  },

  extraReducers: {
    [getPersonList.pending]: (state, action) => {
      state.loading = true;
    },
    [getPersonList.fulfilled]: (state, action) => {
      state.loading = false;
      state.personsLists = [];
      state.personsLists = [...state.personsLists, ...action.payload];
      console.log(action.payload);
    },
    [getPersonList.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },

    [postEmployee.pending]: (state, action) => {
      state.loading = true;
    },

    [postEmployee.fulfilled]: (state, action) => {
      state.loading = false;
      state.personnels = [];
      let _personnels = [...state.personnels, ...action.payload];
      const updatedArr = _personnels.map((obj) => {
        return {
          value: obj.id,
          label: obj.fullname,
        };
      });

      state.personnels = [...state.personnels, ...updatedArr];
      console.log(state.personnels);
    },

    [postEmployee.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [createPerson.pending]: (state, action) => {
      state.loading = true;
    },
    [createPerson.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [createPerson.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [updatePerson.pending]: (state, action) => {
      state.loading = true;
    },
    [updatePerson.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [updatePerson.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [getPersonById.pending]: (state, action) => {
      state.loading = true;
    },
    [getPersonById.fulfilled]: (state, action) => {
      state.loading = false;
      state.personnelReport=action?.payload;
      console.log(action.payload);
    },
    [getPersonById.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [getPersonZktecoById.pending]: (state, action) => {
      state.loading = true;
    },
    [getPersonZktecoById.fulfilled]: (state, action) => {
      state.loading = false;
      state.personnelReportZk=action?.payload;
      console.log(action.payload);
    },
    [getPersonZktecoById.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [getAPerson.pending]: (state, action) => {
      state.loading = true;
    },
    [getAPerson.fulfilled]: (state, action) => {
      state.loading = false;
      // console.log(action.payload);
    },
    [getAPerson.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
  },

});

export const {updatePersonnelReport, resetPersonnelReport, updateCurrentPage}= manageEmpSlice.actions;
export default manageEmpSlice.reducer;
